/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

function SettingSection({ sectionTitleId, children }) {
  return (
    <div className="dtv-html5-c-setting__section">
      {!!sectionTitleId && (
        <h2 className="dtv-html5-c-setting__title">
          <FormattedMessage id={`settings.${sectionTitleId}.title`} />
        </h2>
      )}

      {children}
    </div>
  );
}

SettingSection.defaultProps = {
  children: undefined,
  sectionTitleId: '',
};

SettingSection.propTypes = {
  children: PropTypes.node,
  sectionTitleId: PropTypes.string,
};

export default memo(SettingSection);
